import { ApiMethodDeclaration } from '..';

type ParamsData = {
    adminEmail: string;
    startDate: string;
    endDate: string;
};

type ResponseData = Array<{
    date: string;
    workingHours: number;
    workingMinutes: number;
    totalRequests: number;
    photosAdded: number;
    textsChanged: number;
    statusesChanged: number;
}>;

export const getAllAdminsActivityStats: ApiMethodDeclaration<ParamsData, ResponseData> = (
    params,
) => ({
    url: '/admins/activity/all/stats',
    method: 'GET',
    params: {
        adminEmail: params.adminEmail || 'all',
        startDate: params.startDate,
        endDate: params.endDate,
    },
});
